import { Direction, Directionality } from '@angular/cdk/bidi';
import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';

const RTL_CULTURES = new Set(['ar']);

@Injectable({ providedIn: 'root' })
export class CustomDirectionality extends Directionality {
  readonly #document = inject(DOCUMENT);

  override value: Direction = 'ltr';

  setByCulture(culture: string): void {
    const direction: Direction = RTL_CULTURES.has(culture) ? 'rtl' : 'ltr';

    this.#document.documentElement.dir = direction;
    this.value = direction;
    this.change.emit(direction);
  }
}
